import { Box, Divider, useTheme } from "@mui/material";
import { RectangularLoader } from "../../molecules/skeleton-loader/RectangularLoader";

export const QuestionnaireBuilderLoader = () => {
  const theme = useTheme();

  return (
    <Box
      display="flex"
      minWidth="100%"
      width="100%"
      height="100%"
      flexDirection="column"
      flexGrow={1}
      overflow="hidden"
      minHeight="100%"
    >
      <Box
        width="100%"
        padding="8px 16px"
        display="flex"
        gap="16px"
        borderBottom={`1px solid ${theme.palette.custom.secondaryBorder}`}
        bgcolor={theme.palette.custom.primaryBackground}
        alignItems="center"
        justifyContent="space-between"
      >
        <RectangularLoader width="100%" height="22px" />
        <Box display="flex" gap="8px" alignItems="center">
          <RectangularLoader width="70px" height="30px" />
          <RectangularLoader width="70px" height="30px" />
          <RectangularLoader width="70px" height="30px" />
        </Box>
        <Box width="100%" display="flex" gap="12px" alignItems="center" justifyContent="flex-end">
          <RectangularLoader width="65px" height="30px" />
          <RectangularLoader width="25px" height="25px" />
        </Box>
      </Box>
      <Box
        display="flex"
        minWidth="100%"
        width="100%"
        height="100%"
        flexGrow={1}
        overflow="hidden"
        minHeight="100%"
      >
        <Box
          display="flex"
          flexDirection="column"
          width="100%"
          maxWidth="320px"
          // height="100%"
          flex={1}
          padding="16px"
          gap="16px"
          bgcolor={theme.palette.custom.primaryBackground}
          borderRight={`1px solid ${theme.palette.custom.secondaryBorder}`}
          overflow="auto"
          alignItems="start"
          paddingBottom="80px"
        >
          <RectangularLoader width="100%" height="42px" />
          <RectangularLoader width="100%" height="42px" />
          <RectangularLoader width="100%" height="42px" />
          <RectangularLoader width="100%" height="42px" />
          <RectangularLoader width="100%" height="42px" />
          <RectangularLoader width="100%" height="42px" />
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          width="100%"
          height="100%"
          flex={1}
          paddingTop="32px"
          overflow="auto"
          alignItems="center"
          paddingBottom="80px"
        >
          <Box display="flex" flexDirection="column" width="100%" maxWidth="538px" gap="20px">
            <RectangularLoader width="100%" height="42px" />
            <RectangularLoader width="100%" height="42px" />
            <RectangularLoader width="100%" height="42px" />
          </Box>
        </Box>
        <Box
          display="flex"
          width="100%"
          maxWidth="320px"
          height="100%"
          flex={1}
          flexDirection="column"
          // padding="16px"
          bgcolor={theme.palette.custom.primaryBackground}
          borderLeft={`1px solid ${theme.palette.custom.secondaryBorder}`}
          overflow="auto"
          alignItems="start"
          gap="10px"
          paddingBottom="80px"
        >
          <Box
            width="100%"
            padding={"16px 16px 0 16px"}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <RectangularLoader width="100%" height="30px" />
          </Box>
          <Box display="flex" width="100%" padding="0 16px">
            <RectangularLoader width="100%" height="30px" />
          </Box>
          <Divider orientation="horizontal" sx={{ width: "100%" }} />
          <Box width="100%" padding="0 16px" display="flex" gap="10px" flexDirection="column">
            <RectangularLoader width="100%" height="30px" />
            <RectangularLoader width="100%" height="30px" />
            <RectangularLoader width="100%" height="30px" />
          </Box>
          <Divider orientation="horizontal" sx={{ width: "100%" }} />
          <Box width="100%" padding="0 16px" display="flex" gap="10px" flexDirection="column">
            <RectangularLoader width="100%" height="30px" />
            <RectangularLoader width="100%" height="30px" />
            <RectangularLoader width="100%" height="30px" />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
